import {
  Component,
  OnInit,
  Input,
  ContentChild,
  ChangeDetectorRef,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroupDirective } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';

import { DropdownItemModel } from './dropdown-item-model';
import { SedsCheckFormTypeService } from '../../../shared/services/seds-check-form-type/seds-check-form-type.service';
import { SedsFormFieldType } from '../../seds-form-field/enums/seds-form-field-type.enum';
import { SedsPositionsOptions } from '../../../shared/enums/seds-positions-options.enum';
import { SedsThemeColorOptions } from '../../../shared/enums/seds-theme-color-options.enum';

@Component({
    selector: 'seds-form-field-dropdown',
    templateUrl: './seds-form-field-dropdown.component.html',
    styleUrls: ['./seds-form-field-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SedsFormFieldDropdownComponent implements AfterViewInit, OnInit, OnChanges {
  @Input()
  controlName = '';
  @Input()
  disabled = false;
  @Input()
  iconName = '';
  @Input()
  isMultiple = false;
  @Input()
  label = '';
  @Input()
  optionList: DropdownItemModel[] = [];
  @Input()
  warningColor = false;
  @Input()
  required = false;
  @Input()
  tabindex?: number;

  @Input()
  model: any;
  @Output()
  modelChange = new EventEmitter<any>();

  formControl!: FormControl;
  iconFieldStatus = 'expand_more';
  iconPosition = SedsPositionsOptions;
  type = SedsFormFieldType.DROPDOWN;

  customStyle = '';
  fontOption = 'seds-option-fonts';
  currentCheckboxColor = 'mat-option-primary' + ' ' + this.fontOption;

  @ContentChild(MatFormFieldControl) _control!: any;

  constructor(
    private readonly cdref: ChangeDetectorRef,
    private readonly checkFormTypeService: SedsCheckFormTypeService,
    private readonly rootFormGroup: FormGroupDirective
  ) {}

  ngOnInit(): void {
    this.update();
  }

  ngAfterViewInit(): void {
    this.checkIcon();
    if (this.tabindex === undefined) {
      console.warn(`Missing tabindex on seds-form-field-dropdown with label \"${this.label}.\"`);
    }
    this.cdref.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iconName']) {
      this.checkIcon();
    }

    if (changes['checkboxColor']) {
      this.currentCheckboxColor = SedsThemeColorOptions.PRIMARY + ' ' + this.fontOption;
    }
  }

  private checkIcon() {
    if (this.iconName === '') {
      if (this.isMultiple) {
        this.customStyle = 'custom-panel-without-icon-multiple';
      } else {
        this.customStyle = 'custom-panel-without-icon';
      }
    } else {
      if (this.isMultiple) {
        this.customStyle = 'custom-panel-with-icon-multiple';
      } else {
        this.customStyle = 'custom-panel-with-icon';
      }
    }
  }

  public update(): void {
    if (this.checkFormTypeService.isReactiveForm(this.model, this.controlName)) {
      this.formControl = this.rootFormGroup.control.get(this.controlName) as FormControl;
      this.cdref.detectChanges();
      setTimeout(() => {
        if (this._control !== undefined) {
          this._control.ngControl = this.formControl;
        }
      }, 0);
    }
  }

  changeValue(event: any): void {
    this.modelChange.emit(event.value);
  }

  openChangeStatus(event: any): void {
    if (event) {
      this.iconFieldStatus = 'expand_less';
    } else {
      this.iconFieldStatus = 'expand_more';
    }
  }
}
